import React from 'react';
import { Zap, ShieldCheck, Headphones, Code2, Layers, Users } from 'lucide-react';
import Ornament from './Ornament';
import { useI18n } from '../context/I18nContext';

export default function Features() {
  const { tr } = useI18n();

  const features = [
    {
      icon: Zap,
      title: tr('features.1_title', 'Uzman Performans'),
      text: tr('features.1_text', 'C++, Python ve MySQL optimizasyonu ile 60+ FPS stabilite. Yüksek player sayısında bile pürüzsüz oynanış.'),
    },
    {
      icon: ShieldCheck,
      title: tr('features.2_title', 'Kurşungeçirmez Güvenlik'),
      text: tr('features.2_text', 'Anti-cheat entegrasyonu, DDoS koruma, güncel güvenlik yamaları ve düzenli denetim.'),
    },
    {
      icon: Code2,
      title: tr('features.3_title', 'Modüler Sistemler'),
      text: tr('features.3_text', 'Her paket bağımsız olarak entegre edilebilir. Sunucu mimarinize göre özelleştirilir.'),
    },
    {
      icon: Layers,
      title: tr('features.4_title', '3D Model & UI'),
      text: tr('features.4_text', 'Özel karakterler, silahlar, zırhlar ve modern UI kitleri ile eşsiz bir görsel deneyim.'),
    },
    {
      icon: Headphones,
      title: tr('features.5_title', '7/24 Uzman Destek'),
      text: tr('features.5_text', 'Discord & WhatsApp üzerinden ekibimize her zaman ulaşın. Ortalama yanıt süresi 8 dk.'),
    },
    {
      icon: Users,
      title: tr('features.6_title', '500+ Sunucu Ağı'),
      text: tr('features.6_text', 'Dünya çapında güvendiği topluluk. Aegis çözümleri 40+ ülkede aktif olarak kullanılıyor.'),
    },
  ];

  return (
    <section className="relative py-20 lg:py-28">
      <div className="absolute inset-x-0 top-0 h-40 glow-radial pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <Ornament className="mb-6" />
          <div className="text-xs font-bold tracking-[0.32em] text-[#e4b44e]/85 mb-3">{tr('features.eyebrow', 'NEDEN AEGIS?')}</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black text-white leading-[1.05]">
            <span dangerouslySetInnerHTML={{ __html: tr('features.title1', 'Efsanenin <span class="gold-text">Arkasındaki Güç</span>') }} />
          </h2>
          <p className="text-white/60 mt-4 text-lg">{tr('features.subtitle', 'Aegis Studios, yalnızca dosya satmaz — sunucunuzun kaderini birlikte yazar.')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f, i) => (
            <div
              key={f.title}
              className="group relative rounded-2xl border border-white/8 bg-gradient-to-b from-[#111015]/80 to-[#0a090c]/80 p-8 overflow-hidden card-hover"
              style={{ animationDelay: `${i * 60}ms` }}
            >
              <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-[#e4b44e]/0 group-hover:bg-[#e4b44e]/10 blur-2xl transition duration-500" />
              <div className="relative">
                <div className="w-14 h-14 rounded-2xl bg-[#e4b44e]/10 border border-[#e4b44e]/30 flex items-center justify-center mb-6 group-hover:bg-[#e4b44e]/20 group-hover:rotate-6 transition duration-500">
                  <f.icon className="w-6 h-6 text-[#f4d896]" strokeWidth={2} />
                </div>
                <h3 className="font-display text-xl font-bold text-white mb-3">{f.title}</h3>
                <p className="text-white/60 leading-relaxed text-sm">{f.text}</p>
                <div className="mt-6 flex items-center gap-2 text-xs font-bold tracking-widest text-[#e4b44e]/70 opacity-0 group-hover:opacity-100 translate-x-0 group-hover:translate-x-1 transition duration-300">
                  {tr('features.more', 'DAHA FAZLA →')}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
